import React, { memo } from 'react'
import { useHistory } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import { DatePicker } from '@material-ui/pickers'
import Refresh from '@material-ui/icons/Refresh'

import Button from 'src/components/sharedComponents/CustomButtons/Button'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import TotalStreetCard from 'src/components/reports/reportsBoard/MarketShareReports/TotalStreetCard'
import TotalStreetByTerritoryCard from 'src/components/reports/reportsBoard/MarketShareReports/TotalStreetByTerritoryCard'
import TotalStreetDeportivesCard from 'src/components/reports/reportsBoard/MarketShareReports/TotalStreetDeportivesCard'
import TotalStreetTransportCard from 'src/components/reports/reportsBoard/MarketShareReports/TotalStreetTransportCard '
import TotalStreetResumGraphsCard from 'src/components/reports/reportsBoard/MarketShareReports/TotalStreetResumGraphsCard'

const useStyles = makeStyles(() => ({
  root: {
    '& > *': {
      color: '#fff',
    },
  },
}))

const TotalStreetPage = props => {
  const { selectedDate, handleDateChange } = props
  const classes = useStyles()
  const history = useHistory()

  return (
    <>
      <CardTitle
        title="Total Street por compañía"
        component={
          <DatePicker
            autoOk
            variant="inline"
            views={['year']}
            className={classes.root}
            value={selectedDate}
            maxDate={new Date()}
            onChange={handleDateChange}
          />
        }
      />
      <Button link onClick={() => history.push('/reports/board')}>
        <Refresh /> Volver al Menú
      </Button>
      <TotalStreetCard {...props} />
      <TotalStreetByTerritoryCard {...props} />
      <TotalStreetDeportivesCard {...props} />
      <TotalStreetTransportCard {...props} />
      <TotalStreetResumGraphsCard {...props} />
    </>
  )
}

export default memo(TotalStreetPage)
